import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';

import TeamTables, { RowType } from '../Shared/CustomTable';
import { isCC } from '../../helpers/helpers';
import { useDataTeamsState, useUserState } from '../../store/hooks';
import { useRouter } from '../../helpers/customHooks';

const TableTeam = ({ conference } : { conference: boolean }) => {

  const user = useUserState();
  const { location } = useRouter();
  const { dataTeams: teams } = useDataTeamsState();

  let NFCTeams: RowType[] = [];
  let AFCTeams: RowType[] = [];
  const header = [
    { content: 'TEAM', style: { width: '150px' }, isOrderly: true },
    { content: 'DIVISION', style: { width: '90px' }, isOrderly: true },
    { content: 'WINS', style: { width: '80px' }, isOrderly: true },
    { content: 'LOSSES', style: { width: '80px' }, isOrderly: true },
    { content: 'TIES', style: { width: '80px' }, isOrderly: true },
    { content: '', style: { width: '788px' } }
  ];

  if (teams.NFC && teams.AFC) {
    NFCTeams = Object.values(teams.NFC).map((team) => {
      return ({
        columns: [
          {
            content:
              {
                abbrName: team.teamAbbrName,
                nick: team.teamNick
              },
            print: (content) => (
              <>
                <img src={`/assets/images/logos/${content.abbrName}.svg`} alt="" height="15px" width="15px" />
                <b>{content.abbrName} {content.nick}</b>
              </>
            ),
            order: (contentA, contentB) => contentA.nick.localeCompare(contentB.nick)
          },
          {
            content: { fullName: team.divFullName },
            print: (content) => content.fullName,
            order: (contentA, contentB) => contentA.fullName.localeCompare(contentB.fullName)
          },
          {
            content: { wins: team.totalWins },
            print: (content) => content.wins,
            order: (contentA, contentB) => contentA.wins - contentB.wins
          },
          {
            content: { loss: team.totalLoss },
            print: (content) => content.loss,
            order: (contentA, contentB) => contentA.loss - contentB.loss
          },
          {
            content: { ties: team.totalTies },
            print: (content) => content.ties,
            order: (contentA, contentB) => contentA.ties - contentB.ties
          },
          {
            content: (
              <>
                {user.teamId === team.teamId || isCC(user) ?
                  <Link
                    to={{
                      pathname: `/team/${team.confAbbrName}/${team.teamId}/teamPerformance/practices`,
                      search: location.search,
                      state: {
                        toReturn: location.pathname,
                        toReturnSearch: location.search
                      }
                    }}
                  >
                    <Button className="btn-blue">View Team Performance</Button>
                  </Link> :
                  <Link
                    to={{
                      pathname: `/team/${team.confAbbrName}/${team.teamId}/teamPerformance/games`,
                      search: location.search,
                      state: {
                        toReturn: location.pathname,
                        toReturnSearch: location.search
                      }
                    }}
                  >
                    <Button className="btn-blue">View Team Performance</Button>
                  </Link>
                }
                {user.teamId === team.teamId || isCC(user) ?
                  <Link
                    to={{
                      pathname: `/team/${team.confAbbrName}/${team.teamId}/playerPerformance/practices`,
                      search: location.search,
                      state: {
                        toReturn: location.pathname,
                        toReturnSearch: location.search
                      }
                    }}
                  >
                    <Button className="btn-blue">View Players</Button>
                  </Link> :
                  <Link
                    to={{
                      pathname: `/team/${team.confAbbrName}/${team.teamId}/playerPerformance/games`,
                      search: location.search,
                      state: {
                        toReturn: location.pathname,
                        toReturnSearch: location.search
                      }
                    }}
                  >
                    <Button className="btn-blue">View Players</Button>
                  </Link>
                }
              </>
            )
          }
        ],
        id: team.teamId as string
      });
    });

    AFCTeams = Object.values(teams.AFC).map((team) => {
      return ({
        columns: [
          {
            content:
              {
                abbrName: team.teamAbbrName,
                nick: team.teamNick
              },
            print: (content) => (
              <>
                <img src={`/assets/images/logos/${content.abbrName}.svg`} alt="" height="15px" />
                <b>{content.abbrName} {content.nick}</b>
              </>
            ),
            order: (contentA, contentB) => contentA.nick.localeCompare(contentB.nick)
          },
          {
            content: { fullName: team.divFullName },
            print: (content) => content.fullName,
            order: (contentA, contentB) => contentA.fullName.localeCompare(contentB.fullName)
          },
          {
            content: { wins: team.totalWins },
            print: (content) => content.wins,
            order: (contentA, contentB) => contentA.wins - contentB.wins
          },
          {
            content: { loss: team.totalLoss },
            print: (content) => content.loss,
            order: (contentA, contentB) => contentA.loss - contentB.loss
          },
          {
            content: { ties: team.totalTies },
            print: (content) => content.ties,
            order: (contentA, contentB) => contentA.ties - contentB.ties
          },
          {
            content: (
              <>{user.teamId === team.teamId || isCC(user) ?
                <Link
                  to={{
                    pathname: `/team/${team.confAbbrName}/${team.teamId}/teamPerformance/practices`,
                    search: location.search,
                    state: {
                      toReturn: location.pathname,
                      toReturnSearch: location.search
                    }
                  }}
                >
                  <Button className="btn-blue">View Team Performance</Button>
                </Link> :
                <Link
                  to={{
                    pathname: `/team/${team.confAbbrName}/${team.teamId}/teamPerformance/games`,
                    search: location.search,
                    state: {
                      toReturn: location.pathname,
                      toReturnSearch: location.search
                    }
                  }}
                >
                  <Button className="btn-blue">View Team Performance</Button>
                </Link>
              }
                {user.teamId === team.teamId || isCC(user) ?
                  <Link
                    to={{
                      pathname: `/team/${team.confAbbrName}/${team.teamId}/playerPerformance/practices`,
                      search: location.search,
                      state: {
                        toReturn: location.pathname,
                        toReturnSearch: location.search
                      }
                    }}
                  >
                    <Button className="btn-blue">View Players</Button>
                  </Link> :
                  <Link
                    to={{
                      pathname: `/team/${team.confAbbrName}/${team.teamId}/playerPerformance/games`,
                      search: location.search,
                      state: {
                        toReturn: location.pathname,
                        toReturnSearch: location.search
                      }
                    }}
                  >
                    <Button className="btn-blue">View Players</Button>
                  </Link>
                }
              </>
            )
          }
        ],
        id: team.teamId as string
      });
    });
  }

  const NFCComponent = <Fragment key={'table-1'}>
    <div className="title-t">
      <img src="assets/images/conferences/NFC.svg" alt="" width="30px" />
      <label>National Football Conference</label>
    </div>
    <TeamTables
      classTable="teams-table"
      headers={header}
      rows={NFCTeams}
      default={{ orderColumn: -2 }}
      isCombinedTable={true}
    />
  </Fragment>;
  const AFCComponent = <Fragment key={'table-2'}>
    <div className="title-t">
      <img src="assets/images/conferences/AFC.svg" alt="" width="30px" />
      <label>American Football Conference</label>
    </div>
    <TeamTables
      classTable="teams-table"
      headers={header}
      rows={AFCTeams}
      default={{ orderColumn: -2 }}
      isCombinedTable={true}
    />
  </Fragment>;
  
  const Tables = [NFCComponent, AFCComponent];

  return conference ? <>{Tables.reverse()}</> : <>{Tables}</>;
};

export default TableTeam;
